var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEqStretch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4L4 6M4 6L6 8M4 6H20M20 6L18 4M20 6L18 8",
    stroke: "#3F3F3F",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4L2 8",
    stroke: "#3F3F3F",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4L22 8",
    stroke: "#3F3F3F",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 18,
    r: 2.5,
    stroke: "#3F3F3F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 18,
    r: 2.5,
    stroke: "#3F3F3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82929 17C7.69759 16.6274 7.49436 16.2885 7.23611 16H8.76389C8.50564 16.2885 8.30241 16.6274 8.17071 17H7.82929ZM13.8293 17C13.6976 16.6274 13.4944 16.2885 13.2361 16H23C23.2761 16 23.5 16.2239 23.5 16.5C23.5 16.7761 23.2761 17 23 17H13.8293ZM2.17071 17C2.30241 16.6274 2.50564 16.2885 2.76389 16H1.5C0.947715 16 0.5 16.4477 0.5 17V18C0.5 18.2761 0.723858 18.5 1 18.5C1.27614 18.5 1.5 18.2761 1.5 18V17H2.17071Z",
    fill: "#3F3F3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17.5V14.5C1 13.9477 1.44772 13.5 2 13.5H22C22.5523 13.5 23 13.9477 23 14.5V16.5",
    stroke: "#3F3F3F",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.5C22.2761 20.5 22.5 20.2761 22.5 20C22.5 19.7239 22.2761 19.5 22 19.5V20.5ZM19 19.5C18.7239 19.5 18.5 19.7239 18.5 20C18.5 20.2761 18.7239 20.5 19 20.5V19.5ZM20.0882 17V20H21.0882V17H20.0882ZM20.5882 20.5H22V19.5H20.5882V20.5ZM20.5882 19.5H19V20.5H20.5882V19.5Z",
    fill: "#3F3F3F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqStretch);
export default __webpack_public_path__ + "static/media/eq-stretch.0429d35431c5cd25b9568d4828829d71.svg";
export { ForwardRef as ReactComponent };